import { createApiBuilderFromCtpClient } from '@commercetools/platform-sdk';
import SdkAuth from '@commercetools/sdk-auth';
import { ClientBuilder } from '@commercetools/sdk-client-v2';

export function cachedFetch(url: string, opts: RequestInit = {}) {
  if (url.includes('product-projections')) {
    return fetch(url, {
      ...opts,
      next: {
        revalidate: process.env.NEXT_PUBLIC_DATA_MODE === 'staging' ? 60 : 300,
      },
    });
  }

  return fetch(url, opts);
}

export const createCommerceToolsApiClient = ({
  authHost,
  httpHost,
  projectKey,
  clientId,
  clientSecret,
  cache = true,
}: {
  authHost: string;
  httpHost: string;
  projectKey: string;
  clientId: string;
  clientSecret: string;
  cache?: boolean;
}) => {
  const client = new ClientBuilder()
    .withClientCredentialsFlow({
      host: authHost,
      projectKey,
      credentials: {
        clientId,
        clientSecret,
      },
      fetch: fetch,
    })
    .withHttpMiddleware({
      host: httpHost,
      fetch: cache ? cachedFetch : fetch,
    })
    .build();

  return createApiBuilderFromCtpClient(client).withProjectKey({
    projectKey,
  });
};

export const createCommerceToolsAuthClient = ({
  authHost,
  projectKey,
  clientId,
  clientSecret,
}: {
  authHost: string;
  projectKey: string;
  clientId: string;
  clientSecret: string;
}): SdkAuth =>
  new SdkAuth({
    host: authHost,
    projectKey,
    credentials: {
      clientId,
      clientSecret,
    },
    scopes: [
      `create_anonymous_token:${projectKey}`,
      `view_products:${projectKey}`,
      `manage_my_orders:${projectKey}`,
      `manage_my_profile:${projectKey}`,
      `manage_my_payments:${projectKey}`,
    ],
  });
